import { noop } from "lodash-es";
import { createContext, useMemo } from "react";

import { IKycContextApplicationFragment } from "./KycContext.generated";

export interface IKycContext {
    unitApplication: IKycContextApplicationFragment | undefined;

    refetchApplication(): void;
}

export const KycContext = createContext<IKycContext>({ unitApplication: undefined, refetchApplication: noop });

interface IKycContextProviderProps {
    unitApplication: IKycContextApplicationFragment | undefined;

    refetchApplication(): void;
}

export const KycContextProvider: React.FC<React.PropsWithChildren<IKycContextProviderProps>> = ({
    unitApplication,
    refetchApplication,
    children,
}) => {
    const contextValue = useMemo(
        (): IKycContext => ({ unitApplication, refetchApplication }),
        [unitApplication, refetchApplication],
    );

    return <KycContext.Provider value={contextValue}>{children}</KycContext.Provider>;
};
